// Copyright (c) 2019 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";
import { FormattedMessage, defineMessages } from "react-intl";

import { RoutedProps, withRouter } from "view/reactrouterinterceptor";
import { ActionType, IAction, IActionSortTable, raiseAction } from "actions";
import { IState } from "states/states";

import ConditionList from "view/comp/ConditionList";
import ModuleList from "view/comp/ModuleList";
import SiteBar, { ISiteBarSearchFieldProps } from "view/comp/SiteBar";

// uses webpack definitions
declare const IS_CLOUD: boolean;

interface IModulesConditionsProps {
  showConditions: boolean;
  showModules: boolean;
}

const mapStateToProps = (state: IState) => {
  const curUser = state.site.userList?.find((curItem) => curItem.secId === state.site.user?.secId);
  const isLocalAdminUser = !IS_CLOUD && state.site.user?.secId === "admin";

  const props: IModulesConditionsProps = {
    showConditions:
      (Boolean(curUser?.accessRights.controllerAdmin) || isLocalAdminUser) &&
      Boolean(state.para.parameter?.condition.length),
    showModules:
      (Boolean(curUser?.accessRights.controllerAdmin) || isLocalAdminUser) &&
      Boolean(state.para.parameter?.module.length),
  };
  return props;
};

interface IModulesConditionsDispatch {
  onSort: (sort: IActionSortTable) => void;
}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IModulesConditionsDispatch = {
    onSort: (sort: IActionSortTable) => {
      dispatch(raiseAction(ActionType.ACT_SORT_TABLE, sort));
    },
  };
  return dispatchProps;
};

const messages = defineMessages({
  placeholderSearchField: {
    id: "Search for modules and/or conditions...",
  },
});

class ModulesConditionsComponent extends React.Component<
  IModulesConditionsProps & IModulesConditionsDispatch & RoutedProps
> {
  public render() {
    const searchFieldProps: ISiteBarSearchFieldProps = {
      placeholder: messages.placeholderSearchField,
    };
    return (
      <>
        <SiteBar showPeriodSelect={false} searchFieldProps={searchFieldProps} />
        <div id="modulesconditions">
          {this.props.showModules && <ModuleList />}
          {this.props.showConditions && <ConditionList />}
        </div>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ModulesConditionsComponent));
